import {
  Box,
  Button,
  Checkbox,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import Layout from "components/structure/Layout";
import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import CommonService from "services/CommonService";
import RoleService from "services/RoleService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import UserService from "services/UserService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import UserCreationService from "services/UserCreationService";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { useTranslation } from "react-i18next";
import DynamicTable from 'components/pages/AccessManagement/Common/DynamicTable';

// Add this mock data at the top of the file, after imports

const AddUser = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const profileOptions = ["Global", "Local"];
  const { user } = AuthData();
  const navigate = useNavigate();
  const { rowData } = location.state || {};
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [userName, setUserName] = useState(rowData?.userName || "");
  const [isActive, setIsActive] = useState(
    rowData?.active === "Active" ? "Active" : "InActive"
  );

  const [formData, setFormData] = useState({
    profile: rowData?.batOneId || "",
    fieldTechnician: "",
    role: rowData?.profileId || "",
    serviceNumber: rowData?.serviceNumber || "",
    remarks: rowData?.remarks || "",
    countryCode: rowData?.countryCode || "",
    email: rowData?.email || "",
    userAttribute: rowData?.userAttribute || "",
  });
  const [selected, setSelected] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);
  const reversedEndDate = rowData?.endDate?.split("/").reverse().join("-");
  const [StartDate, setStartDate] = useState(
    rowData?.endDate ? reversedEndDate : "" || ""
  );

  const [roleOptions, setRoleOptions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [userUpn, setUserUpn] = useState("");


  const fetchRoles = async (profile, countryCode) => {
    try {
      const response = await RoleService.getActiveRolesNewUsers(profile, countryCode);
      if (response.data?.statusCode === 200) {
        setRoleOptions(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      setRoleOptions([]);
      console.error("API call error:", error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await CommonService.fetchCountries();
      if (response.data?.statusCode === 200) {
        setCountries(response.data.response);
      } else {
        console.error("Error fetching roles:", response.data.message);
      }
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  useEffect(() => {
    fetchRoles(rowData?.userAttribute, rowData?.countryCode)
    fetchCountries();
  }, []);


  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name == "userAttribute") {
      fetchRoles(value, formData?.countryCode);
    }
    if (name == "countryCode") {
      fetchRoles(formData?.userAttribute, value);
    }
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const isAllSelected =
    countries.length > 0 && selected.length === countries.length;

  const handleChangeCountry = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  // Add state for table rows
  const [tableRows, setTableRows] = useState([]);

  // Add the rows state handler
  const handleTableRowsChange = (rows) => {
    setTableRows(rows);
  };

  // Add new state for roles and history
  const [initialRoles, setInitialRoles] = useState([]);
  const [profileLinkHistory, setProfileLinkHistory] = useState([]);

  // Replace the fetchUserRoles function in useEffect with this:
  useEffect(() => {
    fetchUserDetails();
  }, [rowData?.userId]);
  const fetchUserDetails = async () => {
    if (rowData?.userId) {
      try {
        const response = await UserCreationService.getUserById(rowData.userId);
        const userData = response?.data?.response;
        // Update form data with user details
        setFormData(prevData => ({
          ...prevData,
          profile: userData.batOneId?.toString() || "",
          serviceNumber: userData.serviceNumber || "",
          remarks: userData.remarks || "",
          countryCode: userData.countryCode || "",
          email: userData.email || "",
          userAttribute: userData.userAttribute || "",
        }));
        fetchRoles(userData.userAttribute, userData.countryCode);
        setUserName(userData.userName || "");
        setIsActive(userData.active ? "Active" : "InActive");
        setUserUpn(userData?.upn)

        // Convert endDate to required format
        if (userData.endDate) {
          setStartDate(dayjs(userData.endDate).format('YYYY-MM-DD'));
        }
        // Format roles for the dynamic table
        if (userData.userProfileLinks) {
          const formattedRoles = userData?.userProfileLinks?.map(role => ({
            roleStartDate: dayjs(role.startDate),
            roleEndDate: dayjs(role.endDate),
            roleName: role.roleName,
            serviceNumber: role.serviceNumber,
            remarks: role.remarks,
            status: role.status ? 'Active' : 'Inactive',
            createdDate: dayjs(role.createdDateTimeUTC).format('DD/MM/YYYY | HH:mm'),
            userProfileLinkId: role.userProfileLinkId,
            isNew: false // Mark existing roles as not new
          }));
          setInitialRoles(formattedRoles);
        }else{
          setInitialRoles([]);
          setTableRows([]);
        }

        // Format history data for the history table
        if (userData.userProfileLinkHistory) {
          const formattedHistory = userData.userProfileLinkHistory.map(history => ({
            roleStartDate: dayjs(history.startDate),
            roleEndDate: dayjs(history.endDate),
            roleName: history.roleName,
            serviceNumber: history.serviceNumber,
            remarks: history.remarks,
            status: history.status ? 'Active' : 'Inactive',
            createdDate: dayjs(history.createdDateTimeUTC).format('DD/MM/YYYY | HH:mm')
          }));
          setProfileLinkHistory(formattedHistory);
        }

      } catch (error) {
        console.error("Error fetching user details:", error);
        setSeverity("error");
        setMessage("Error loading user details");
        setOpenAlert(true);
      }
    }
  };
  // Initial setup for form values based on API response

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // First check for required fields in rows
    const invalidRows = tableRows.filter(row => 
      !row.roleName || !row.roleStartDate || !row.roleEndDate || !row.serviceNumber
    );

    if (invalidRows.length > 0) {
      setOpenAlert(true);
      setSeverity("error");
      setMessage("Please fill in all required fields for roles");
      return;
    }

    const userStartDate = dayjs().format('YYYY-MM-DD');
    const userEndDate = dayjs(StartDate).format('YYYY-MM-DD');

    // Then validate dates for all rows
    for (let row of tableRows) {
      if (!validateUserRoleDates(row, userStartDate, userEndDate)) {
        return;
      }
    }

    setLoading(true);
    
    try {
      const payload = {
        userName: userName,
        active: isActive === "Active" ? true : false,
        batOneId: formData.profile,
        serviceNumber: formData.serviceNumber,
        startDate: dayjs().startOf('day').add(5, 'hours').add(30, 'minutes').toISOString(),
        endDate: dayjs(StartDate).startOf('day').add(5, 'hours').add(30, 'minutes').toISOString(),
        remarks: formData.remarks,
        isDeleted: false,
        email: formData?.email,
        profileId: formData.role,
        countryCode: formData.countryCode,
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: dayjs().toISOString(),
        modifiedDateTimeUTC: dayjs().toISOString(),
        createdByRoleId: user?.profiles[0]?.profileId, // Assuming user.profileId is available
        upn: batData?.upn || userUpn, // Assuming user.upn is available
        userAttribute: formData?.userAttribute || "", // Assuming user.userAttribute is available

        userProfileLinks: tableRows.map(row => ({
          roleId: row?.roleName,
          startDate: dayjs(row.roleStartDate).startOf('day').add(5, 'hours').add(30, 'minutes').toISOString(),
          endDate: dayjs(row.roleEndDate).startOf('day').add(5, 'hours').add(30, 'minutes').toISOString(),
          serviceNumber: row.serviceNumber,
          remarks: row.remarks,
          status: row.status === 'Active',
        }))
      };

      const response = await UserCreationService.createUserManagement(payload);
      setLoading(false);

      if (response.status === 201) {
        // Show success snackbar
        navigate("/userCreation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
      } else {
        console.error("Failed to submit form");
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      setLoading(false);
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    // Get only new rows (rows that don't exist in initialRoles)
    const newRows = tableRows.filter(row => !initialRoles.some(initRole => 
      initRole.userProfileLinkId === row.userProfileLinkId
    ));

    // First check for required fields in new rows
    const invalidRows = newRows.filter(row => 
      !row.roleName || !row.roleStartDate || !row.roleEndDate || !row.serviceNumber
    );

    if (invalidRows.length > 0) {
      setOpenAlert(true);
      setSeverity("error");
      setMessage("Please fill in all required fields for roles");
      return;
    }

    const userStartDate = rowData?.userId ? dayjs(rowData?.createdDateTimeUTC).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
    const userEndDate = dayjs(StartDate).format('YYYY-MM-DD');

    // Then validate dates for all new rows
    for (let row of newRows) {
      if (!validateUserRoleDates(row, userStartDate, userEndDate)) {
        return;
      }
    }

    setLoading(true);
    try {
      const payload = {
        userId: rowData?.userId,
        userName: userName,
        active: isActive === "Active" ? true : false,
        batOneId: formData.profile,
        serviceNumber: formData.serviceNumber,
        startDate: dayjs().startOf('day').add(5, 'hours').add(30, 'minutes')?.toISOString(),
        endDate: dayjs(StartDate).startOf('day').add(5, 'hours').add(30, 'minutes')?.toISOString(),
        remarks: formData.remarks,
        isDeleted: false,
        email: formData?.email,
        profileId: formData.role,
        countryCode: formData.countryCode,
        createdByUser: user?.userName || "Rahul",
        modifiedByUser: user?.userName || "Rahul",
        createdDateTimeUTC: dayjs().toISOString(),
        modifiedDateTimeUTC: dayjs().toISOString(),
        createdByRoleId: user?.profiles[0]?.profileId, // Assuming user.profileId is available
        upn: userUpn, // Assuming user.upn is available
        userAttribute: formData?.userAttribute || "", // Assuming user.userAttribute is available
        userProfileLinks: tableRows
          .filter(row => !initialRoles.some(initRole => 
            initRole.userProfileLinkId === row.userProfileLinkId
          )) // Filter out rows that exist in initialRoles
          .map(row => ({
            roleId: row?.roleName,
            roleName: row.roleName,
            startDate: dayjs(row?.roleStartDate).startOf('day').add(5, 'hours').add(30, 'minutes')?.toISOString(),
            endDate: dayjs(row?.roleEndDate).startOf('day').add(5, 'hours').add(30, 'minutes')?.toISOString(),
            serviceNumber: row.serviceNumber,
            remarks: row.remarks,
            status: row.status === 'Active'
          }))
      };

      

      if (payload?.active == false) {
        Object.assign(payload, {
          accessRemovalDate: new Date().toISOString(),
        });
      }
      const response = await UserCreationService.updateUserManagement(payload);
      if (response.status === 200) {
        // Show success snackbar
        navigate("/userCreation");
        setSeverity("success");
        setMessage("Updated successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
      setLoading(false);
    }
  };

  const [profileData, setProfileData] = useState([]);

  const handleChangeText = (e) => {
    setFormData({ ...formData, profile: e.target.value });
  };

  const [batData, setBatData] = useState("");

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchProfileData = async () => {
      if (formData.profile && !rowData?.userId) {
        if (formData.profile.length > 7) {
          try {
            const response = await UserService.FindAdUser(formData.profile);

            setBatData(response?.data?.response);
            setUserName(
              `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
                }`.trim()
            );
          } catch (error) {
            console.error("Error fetching profile data:", error);
            setSeverity("error");
            setMessage("No record found");
            setOpenAlert(true);
            setBatData("");
            setUserName("");
          }
        } else {
        }
      }
    };

    fetchProfileData();
  }, [formData.profile]);

  const toggleIsActive = () => {
    setIsActive((prevIsActive) =>
      prevIsActive === "Active" ? "InActive" : "Active"
    );
  };

  const handleChangeDate = (date) => {
    const dateValue = new Date(date);
    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, "0");
    const day = String(dateValue.getDate()).padStart(2, "0");
    let val = `${year}-${month}-${day}`;
    setStartDate(val);
  };

  const CustomDivider = () => (
    <Divider
      sx={{
        width: "100%",
        backgroundColor: "#E0E0E0",
        my: 1,
      }}
    />
  );

  // Add validation function before handleSubmit
// Add validation function before handleSubmit
  const validateUserRoleDates = (row, userStartDate, userEndDate) => {
    const roleStartDateTime = dayjs(row.roleStartDate);
    const roleEndDateTime = dayjs(row.roleEndDate);
    const userStart = dayjs(userStartDate);
    const userEnd = dayjs(userEndDate);

    // Role Start Date Validations
    if (roleStartDateTime.isBefore(userStart)) {
      setSeverity("error");
      setMessage(`User is onboarded in Agri360 on ${userStart.format('DD/MM/YYYY')}. Please select a date after the same.`);
      setOpenAlert(true);
      return false;
    }
    if (roleStartDateTime.isAfter(userEnd)) {
      setSeverity("error");
      setMessage(`User is onboarded in Agri360 on ${userEnd.format('DD/MM/YYYY')}. Please select a date before the same.`);
      setOpenAlert(true);
      return false;
    }
    if (roleStartDateTime.isBefore(userStart)) {
      setSeverity("error");
      setMessage('Role Start Date cannot be Past date, Please select current date or future date.');
      setOpenAlert(true);
      return false;
    }
    if (roleStartDateTime.isAfter(roleEndDateTime)) {
      setSeverity("error");
      setMessage('Role Start Date Can not be same or after the Role End date.');
      setOpenAlert(true);
      return false;
    }

    // Role End Date Validations
    if (roleEndDateTime.isBefore(userStart)) {
      setSeverity("error");
      setMessage(`User is onboarded in Agri360 on ${userStart.format('DD/MM/YYYY')}. Please select a date after the same.`);
      setOpenAlert(true);
      return false;
    }
    if (roleEndDateTime.isAfter(userEnd)) {
      setSeverity("error");
      setMessage(`User End Date in Agri360 is ${userEnd.format('DD/MM/YYYY')}. Please select a date before the same.`);
      setOpenAlert(true);
      return false;
    }
    if (roleEndDateTime.isBefore(userStart)) {
      setSeverity("error");
      setMessage('Role End Date cannot be Past date, please select future date.');
      setOpenAlert(true);
      return false;
    }
    if (roleEndDateTime.isBefore(roleStartDateTime) || roleEndDateTime.isSame(roleStartDateTime)) {
      setSeverity("error");
      setMessage('Role End Date Can not be same or before the Role Start date');
      setOpenAlert(true);
      return false;
    }
    
    return true;
  };

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
          }}
        >
          <Box
            sx={{
              background: "#ffffff",
              width: "100%",
                  maxWidth: (batData === "" && !rowData?.userId) ? "443px" :  "calc(100% - 60px)",
              margin: "0 30px",
              // p: 2,
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              borderRadius: "16px",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 2,
                  minHeight: (batData === "" && !rowData?.userId) ? "160px" : "", 
               justifyContent: (batData == "" && !rowData?.userId) ? "center" : "" }}>
              <TextField
                id="profile"
                label={
                  <span style={{ fontStyle: 'italic' }}>
                    {t("batOneId")}
                    {!formData.profile && <span style={{ color: '#d32f2f' }}> *</span>}
                  </span>
                }
                value={formData.profile}
                name="profile"
                onChange={handleChangeText}
                sx={{ width: "403px" }}
                disabled={rowData?.userId || (formData.profile && batData !== "")}
                InputProps={{
                  endAdornment: (
                    <img
                      src={require('assets/user-access/inputSearch.png')}
                      alt="search"
                      style={{ width: '20px', height: '20px' }}
                    />
                  ),
                }}
              />
              {(batData == "" && !rowData?.userId) && (
                <Button
                  sx={{
                    borderRadius: 2,
                    background: "#102A62",
                    height: 40,
                    color: "#ffffff",
                    fontWeight: 600,
                    backgroundColor: "#737D86",
                    width: "100px",
                    marginTop: "20px",
                    "&:hover": {
                      backgroundColor: "#737D86",
                    },
                  }}
                  onClick={() => navigate(-1)}
                >
                  {t("back")}
                </Button>
              )}
            </Box>

            {(batData !== "" || rowData?.userId) && <CustomDivider />}


            {(batData !== "" || rowData?.userId) && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "center",
                  gap: 2,
                  width: "403px",
                }}
              >
                <Box sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flex: 1,
                  alignItems: "center",
                }}>
                  <Typography>
                    {t("administratorAccess.name")}: {batData?.givenName || ""}{" "}
                    {batData?.surName}{" "}
                    {batData?.givenName || batData?.surName ? "" : `${userName}`}
                  </Typography>
                  <Typography>
                    {t("administratorAccess.email")}:{" "}
                    {batData?.mail || rowData?.email || ""}
                  </Typography>
                </Box>
              </Box>
            )}

            {(batData !== "" || rowData?.userId) && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  width: "60%",
                  alignSelf: "center",
                }}
              >
                <Box sx={{ flex: 1 }} >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer sx={{ width: "100%", paddingTop: "5px" }} components={["DatePicker"]}>
                      <DatePicker
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {

                          },
                        }}
                        id="endDate"
                        name="endDate"
                        open={open}
                        onClose={() => setOpen(false)}
                        label={<span style={{ fontStyle: 'italic' }}>{t("administratorAccess.endDate")}<span style={{ color: '#d32f2f' }}>*</span></span>}
                        format="DD/MM/YYYY"
                        minDate={dayjs()}
                        value={StartDate ? dayjs(StartDate) : null}
                        onChange={(date) => handleChangeDate(date)}
                        renderInput={(params) => <TextField {...params} />}
                        slotProps={{
                          field: {
                            readOnly: true,
                          },
                          textField: {
                            onClick: () => setOpen(true),
                          },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Box>

                <Box sx={{ flex: 1, pt: "5px" }}>
                  <TextField
                    select
                    id="attribute"
                    label={<span style={{ fontStyle: 'italic' }}>{t("profile")}<span style={{ color: '#d32f2f' }}>*</span></span>}
                    value={formData.userAttribute || ""}
                    name="userAttribute"
                    onChange={handleChange}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {

                      },
                    }}
                  >
                    {profileOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
              </Box>
            )}

            {(batData !== "" || rowData?.userId) && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                  width: "60%",
                  alignSelf: "center",
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <TextField
                    select
                    id="cropStageCountryDetail"
                    label={<span style={{ fontStyle: 'italic' }}>{t("Country")}<span style={{ color: '#d32f2f' }}>*</span></span>}
                    name="countryCode"
                    value={formData.countryCode}
                    onChange={handleChange}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {

                      },
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: { maxHeight: 200 },
                        },
                      },
                    }}
                  >
                    {countries.map((option) => (
                      <MenuItem
                        key={option.countryName}
                        value={option.countryCode}
                        sx={{
                          maxHeight: "30px !important",
                          fontSize: "16px",
                        }}
                      >
                        {option.countryName}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <TextField
                    label={<span style={{ fontStyle: 'italic' }}>{t("serviceNumber")}<span style={{ color: '#d32f2f' }}>*</span></span>}
                    name="serviceNumber"
                    onChange={handleChange}
                    value={formData.serviceNumber}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {

                      },
                    }}
                  />
                </Box>
              </Box>
            )}


            {(batData !== "" || rowData?.userId) && (
              <TextField
                label={<span style={{ fontStyle: 'italic' }}>{t("remarks")}</span>}
                name="remarks"
                onChange={handleChange}
                value={formData.remarks}
                multiline
                rows={3}
                fullWidth
                sx={{ width: "60%", alignSelf: "center", "& .MuiInputBase-root": {} }}
              // disabled={rowData?.userId ? true : false}
              />
            )}

            {(batData !== "" || rowData?.userId) && <CustomDivider />}

            {(batData !== "" || rowData?.userId) && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    pb: 2,
                    cursor: "pointer",
                  }}
                  onClick={toggleIsActive}
                >
                  <img
                    src={isActive === "Active" ? CheckboxTick : CheckboxUntick}
                    alt="checkbox"
                  />
                  <Typography>
                    {isActive === "Active" ? "Active" : "Inactive"}
                  </Typography>
                </Box>
              </Box>
            )}

            {(batData !== "" || rowData?.userId) && <CustomDivider />}

            {/* Add Dynamic Table */}

            {(batData !== "" || rowData?.userId) &&
              <Box sx={{ padding: "20px", backgroundColor: "#f9f9f9" }}>
                {/* Current Roles Table */}
                <DynamicTable
                  headers={[
                    'Role Start Date',
                    'Role End Date',
                    'Role Name',
                    'Service Number',
                    'Remarks',
                    'Status',
                    'Created/Modified Date'
                  ]}
                  onRowsChange={handleTableRowsChange}
                  roleOptions={roleOptions}
                  initialRows={initialRoles}
                  userEndDate={StartDate}
                  userStartDates={rowData?.userId ? dayjs(rowData?.startDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD')}
                  setMessage={setMessage}
                  setSeverity={setSeverity}
                  setOpenAlert={setOpenAlert}
                  onDeactivateRole={async (userProfileLinkId, serviceNumber) => {
                    try {
                      const response = await UserService.deactivateUserRole(userProfileLinkId, serviceNumber);
                      return response;
                    } catch (error) {
                      throw new Error("Failed to deactivate role");
                    }
                  }}
                  onRefreshData={() => fetchUserDetails()}
                />


              </Box>
            }

            {(batData !== "" || rowData?.userId) && (
              <Box
                sx={{
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                  gap: "20px",
                  marginBottom: "30px",
                }}
              >
                <Button
                  sx={{
                    borderRadius: 2,
                    background: "#102A62",
                    height: 54,
                    color: "#ffffff",
                    fontWeight: 600,
                    backgroundColor: "#737D86",
                    width: { xs: "100%", md: "156px" },
                    "&:hover": {
                      backgroundColor: "#737D86",
                    },
                  }}
                  onClick={() => navigate("/userCreation")}
                >
                  {t("back")}
                </Button>
                <Button
                  sx={{
                    borderRadius: 2,
                    background: "#EF7D00",
                    color: "#ffffff",
                    fontWeight: 600,
                    height: 54,
                    width: { xs: "100%", md: "156px" },
                    "&:hover": {
                      backgroundColor: "#EF7D00",
                    },
                  }}
                  disabled={loading || formData.serviceNumber == '' || formData.countryCode == "" || StartDate == "" || formData.userAttribute == ""}
                  onClick={rowData?.userId ? handleUpdate : handleSubmit}
                >
                  {t("submit")}
                </Button>
              </Box>
            )}
            {/* History Table */}
            {(batData !== "" || rowData?.userId) &&

              <Box sx={{ padding: "0px 60px 60px 60px", marginBottom: "30px" }}>
                {profileLinkHistory.length > 0 && (
                  <>
                    <DynamicTable
                      headers={[
                        'Role Start Date',
                        'Role End Date',
                        'Role Name',
                        'Service Number',
                        'Remarks',
                        'Status',
                        'Created/Modified Date'
                      ]}
                      onRowsChange={() => { }} // No changes allowed in history
                      roleOptions={[]}
                      initialRows={profileLinkHistory}
                      userEndDate={null}
                      userStartDates={rowData?.userId ? dayjs(rowData?.startDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD')}

                      setMessage={setMessage}
                      setSeverity={setSeverity}
                      setOpenAlert={setOpenAlert}
                      historyMode={true} // Enable history mode styling
                    />
                  </>
                )}
              </Box>
            }
          </Box>
        </Box>
      </Box>
    </LayoutAccessManagement>
  );
};

export default AddUser;
